// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  BulkReassignSubmissionsParams,
  GenericApiResponseExamAttemptReportResponse,
  GenericApiResponseListTaskSubmissionVersionSummary,
  GenericApiResponseModule,
  GenericApiResponseSubmission,
  GenericApiResponseTaskSubmissionVersionDetail,
  GenericApiResponseUnionGradingNoneType,
  GrantExamAttemptRequest,
  HTTPValidationError,
  ListTaskSubmissionHistoryParams,
  ModuleGradeOverrideRequest,
  OverrideModuleGradeHeaders,
  ReassignSubmissionParams,
  SubmissionCreateRequest,
} from '../../models';

/**
 * Get version history for a task submission (metadata only, excludes content for performance)
 * @summary List Submission History
 */
export const listTaskSubmissionHistory = (
  courseId: string,
  moduleId: string,
  taskId: string,
  params?: ListTaskSubmissionHistoryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListTaskSubmissionVersionSummary>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submission/history`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListTaskSubmissionHistoryQueryKey = (
  courseId: string,
  moduleId: string,
  taskId: string,
  params?: ListTaskSubmissionHistoryParams,
) => {
  return [
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submission/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListTaskSubmissionHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listTaskSubmissionHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  params?: ListTaskSubmissionHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskSubmissionHistory>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTaskSubmissionHistoryQueryKey(courseId, moduleId, taskId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTaskSubmissionHistory>>> = ({ signal }) =>
    listTaskSubmissionHistory(courseId, moduleId, taskId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(courseId && moduleId && taskId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTaskSubmissionHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTaskSubmissionHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listTaskSubmissionHistory>>>;
export type ListTaskSubmissionHistoryQueryError = AxiosError<void | HTTPValidationError>;

export function useListTaskSubmissionHistory<
  TData = Awaited<ReturnType<typeof listTaskSubmissionHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  params: undefined | ListTaskSubmissionHistoryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskSubmissionHistory>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof listTaskSubmissionHistory>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTaskSubmissionHistory<
  TData = Awaited<ReturnType<typeof listTaskSubmissionHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  params?: ListTaskSubmissionHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskSubmissionHistory>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof listTaskSubmissionHistory>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTaskSubmissionHistory<
  TData = Awaited<ReturnType<typeof listTaskSubmissionHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  params?: ListTaskSubmissionHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskSubmissionHistory>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Submission History
 */

export function useListTaskSubmissionHistory<
  TData = Awaited<ReturnType<typeof listTaskSubmissionHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  params?: ListTaskSubmissionHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskSubmissionHistory>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTaskSubmissionHistoryQueryOptions(courseId, moduleId, taskId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get full content of a specific task submission version for preview/restore
 * @summary Get Submission Version
 */
export const getTaskSubmissionVersion = (
  courseId: string,
  moduleId: string,
  taskId: string,
  versionSeq: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseTaskSubmissionVersionDetail>> => {
  return axios.get(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submission/history/${versionSeq}`,
    options,
  );
};

export const getGetTaskSubmissionVersionQueryKey = (
  courseId: string,
  moduleId: string,
  taskId: string,
  versionSeq: number,
) => {
  return [`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submission/history/${versionSeq}`] as const;
};

export const getGetTaskSubmissionVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskSubmissionVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  versionSeq: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTaskSubmissionVersionQueryKey(courseId, moduleId, taskId, versionSeq);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskSubmissionVersion>>> = ({ signal }) =>
    getTaskSubmissionVersion(courseId, moduleId, taskId, versionSeq, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(courseId && moduleId && taskId && versionSeq),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionVersion>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetTaskSubmissionVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskSubmissionVersion>>>;
export type GetTaskSubmissionVersionQueryError = AxiosError<void | HTTPValidationError>;

export function useGetTaskSubmissionVersion<
  TData = Awaited<ReturnType<typeof getTaskSubmissionVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  versionSeq: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionVersion>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getTaskSubmissionVersion>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTaskSubmissionVersion<
  TData = Awaited<ReturnType<typeof getTaskSubmissionVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  versionSeq: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionVersion>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTaskSubmissionVersion>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTaskSubmissionVersion<
  TData = Awaited<ReturnType<typeof getTaskSubmissionVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  versionSeq: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Submission Version
 */

export function useGetTaskSubmissionVersion<
  TData = Awaited<ReturnType<typeof getTaskSubmissionVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  versionSeq: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTaskSubmissionVersionQueryOptions(courseId, moduleId, taskId, versionSeq, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get submission of a specific user for a task
 * @summary Get Submission Current User By Task
 */
export const getStudentSubmission = (
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseSubmission>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submissions`, options);
};

export const getGetStudentSubmissionQueryKey = (courseId: string, moduleId: string, taskId: string) => {
  return [`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submissions`] as const;
};

export const getGetStudentSubmissionQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentSubmission>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStudentSubmissionQueryKey(courseId, moduleId, taskId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentSubmission>>> = ({ signal }) =>
    getStudentSubmission(courseId, moduleId, taskId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(courseId && moduleId && taskId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentSubmission>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStudentSubmissionQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentSubmission>>>;
export type GetStudentSubmissionQueryError = AxiosError<void | HTTPValidationError>;

export function useGetStudentSubmission<
  TData = Awaited<ReturnType<typeof getStudentSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentSubmission>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getStudentSubmission>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStudentSubmission<
  TData = Awaited<ReturnType<typeof getStudentSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentSubmission>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getStudentSubmission>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStudentSubmission<
  TData = Awaited<ReturnType<typeof getStudentSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentSubmission>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Submission Current User By Task
 */

export function useGetStudentSubmission<
  TData = Awaited<ReturnType<typeof getStudentSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentSubmission>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStudentSubmissionQueryOptions(courseId, moduleId, taskId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or update submission of a specific user for a task.

Supports optimistic concurrency control via ETag.
If last_known_etag is provided, the update will fail with 409 if the submission
was modified concurrently by another request.
 * @summary Create Update Task Submission
 */
export const createTaskSubmission = (
  courseId: string,
  moduleId: string,
  taskId: string,
  submissionCreateRequest: SubmissionCreateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseSubmission>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submissions`,
    submissionCreateRequest,
    options,
  );
};

export const getCreateTaskSubmissionMutationOptions = <
  TData = Awaited<ReturnType<typeof createTaskSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: SubmissionCreateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createTaskSubmission'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaskSubmission>>,
    { courseId: string; moduleId: string; taskId: string; data: SubmissionCreateRequest }
  > = (props) => {
    const { courseId, moduleId, taskId, data } = props ?? {};

    return createTaskSubmission(courseId, moduleId, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: SubmissionCreateRequest },
    TContext
  >;
};

export type CreateTaskSubmissionMutationResult = NonNullable<Awaited<ReturnType<typeof createTaskSubmission>>>;
export type CreateTaskSubmissionMutationBody = SubmissionCreateRequest;
export type CreateTaskSubmissionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Create Update Task Submission
 */
export const useCreateTaskSubmission = <
  TData = Awaited<ReturnType<typeof createTaskSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: SubmissionCreateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; data: SubmissionCreateRequest },
  TContext
> => {
  const mutationOptions = getCreateTaskSubmissionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Submit module for evaluation
 * @summary Submit Module Submission
 */
export const submitModuleSubmission = (
  courseId: string,
  moduleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModule>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/submit`, undefined, options);
};

export const getSubmitModuleSubmissionMutationOptions = <
  TData = Awaited<ReturnType<typeof submitModuleSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['submitModuleSubmission'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitModuleSubmission>>,
    { courseId: string; moduleId: string }
  > = (props) => {
    const { courseId, moduleId } = props ?? {};

    return submitModuleSubmission(courseId, moduleId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string },
    TContext
  >;
};

export type SubmitModuleSubmissionMutationResult = NonNullable<Awaited<ReturnType<typeof submitModuleSubmission>>>;

export type SubmitModuleSubmissionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Submit Module Submission
 */
export const useSubmitModuleSubmission = <
  TData = Awaited<ReturnType<typeof submitModuleSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { courseId: string; moduleId: string }, TContext> => {
  const mutationOptions = getSubmitModuleSubmissionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Set or overwrite an administratively recorded module grade (admin only).
 * @summary Override Module Grade
 */
export const overrideModuleGrade = (
  userId: string,
  courseId: string,
  moduleId: string,
  moduleGradeOverrideRequest: ModuleGradeOverrideRequest,
  headers?: OverrideModuleGradeHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseUnionGradingNoneType>> => {
  return axios.put(
    `/users/${userId}/courses/${courseId}/modules/${moduleId}/grade-override`,
    moduleGradeOverrideRequest,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getOverrideModuleGradeMutationOptions = <
  TData = Awaited<ReturnType<typeof overrideModuleGrade>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      userId: string;
      courseId: string;
      moduleId: string;
      data: ModuleGradeOverrideRequest;
      headers?: OverrideModuleGradeHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['overrideModuleGrade'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof overrideModuleGrade>>,
    {
      userId: string;
      courseId: string;
      moduleId: string;
      data: ModuleGradeOverrideRequest;
      headers?: OverrideModuleGradeHeaders;
    }
  > = (props) => {
    const { userId, courseId, moduleId, data, headers } = props ?? {};

    return overrideModuleGrade(userId, courseId, moduleId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      userId: string;
      courseId: string;
      moduleId: string;
      data: ModuleGradeOverrideRequest;
      headers?: OverrideModuleGradeHeaders;
    },
    TContext
  >;
};

export type OverrideModuleGradeMutationResult = NonNullable<Awaited<ReturnType<typeof overrideModuleGrade>>>;
export type OverrideModuleGradeMutationBody = ModuleGradeOverrideRequest;
export type OverrideModuleGradeMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Override Module Grade
 */
export const useOverrideModuleGrade = <
  TData = Awaited<ReturnType<typeof overrideModuleGrade>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      userId: string;
      courseId: string;
      moduleId: string;
      data: ModuleGradeOverrideRequest;
      headers?: OverrideModuleGradeHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    userId: string;
    courseId: string;
    moduleId: string;
    data: ModuleGradeOverrideRequest;
    headers?: OverrideModuleGradeHeaders;
  },
  TContext
> => {
  const mutationOptions = getOverrideModuleGradeMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Return submitted module to student
 * @summary Return Module Submission
 */
export const returnModuleSubmission = (
  userId: string,
  courseId: string,
  moduleId: string,
  target: 'student' | 'lecturer',
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(`/users/${userId}/courses/${courseId}/modules/${moduleId}/return-to/${target}`, undefined, options);
};

export const getReturnModuleSubmissionMutationOptions = <
  TData = Awaited<ReturnType<typeof returnModuleSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; target: 'student' | 'lecturer' },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['returnModuleSubmission'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof returnModuleSubmission>>,
    { userId: string; courseId: string; moduleId: string; target: 'student' | 'lecturer' }
  > = (props) => {
    const { userId, courseId, moduleId, target } = props ?? {};

    return returnModuleSubmission(userId, courseId, moduleId, target, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; target: 'student' | 'lecturer' },
    TContext
  >;
};

export type ReturnModuleSubmissionMutationResult = NonNullable<Awaited<ReturnType<typeof returnModuleSubmission>>>;

export type ReturnModuleSubmissionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Return Module Submission
 */
export const useReturnModuleSubmission = <
  TData = Awaited<ReturnType<typeof returnModuleSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; target: 'student' | 'lecturer' },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { userId: string; courseId: string; moduleId: string; target: 'student' | 'lecturer' },
  TContext
> => {
  const mutationOptions = getReturnModuleSubmissionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Cancel a student's current attempt: archive it and reset the submission to draft.
 * @summary Delete Module Submission
 */
export const deleteModuleSubmission = (
  userId: string,
  courseId: string,
  moduleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.delete(`/users/${userId}/courses/${courseId}/modules/${moduleId}/submission`, options);
};

export const getDeleteModuleSubmissionMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteModuleSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteModuleSubmission'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModuleSubmission>>,
    { userId: string; courseId: string; moduleId: string }
  > = (props) => {
    const { userId, courseId, moduleId } = props ?? {};

    return deleteModuleSubmission(userId, courseId, moduleId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string },
    TContext
  >;
};

export type DeleteModuleSubmissionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteModuleSubmission>>>;

export type DeleteModuleSubmissionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Delete Module Submission
 */
export const useDeleteModuleSubmission = <
  TData = Awaited<ReturnType<typeof deleteModuleSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext> => {
  const mutationOptions = getDeleteModuleSubmissionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Archived tasks and grading snapshot for an earlier graded exam on the grade report.
 * @summary Get Exam Attempt Report
 */
export const getExamAttemptReport = (
  userId: string,
  courseId: string,
  moduleId: string,
  attemptNumber: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseExamAttemptReportResponse>> => {
  return axios.get(
    `/users/${userId}/courses/${courseId}/modules/${moduleId}/exam-attempts/${attemptNumber}/report`,
    options,
  );
};

export const getGetExamAttemptReportQueryKey = (
  userId: string,
  courseId: string,
  moduleId: string,
  attemptNumber: number,
) => {
  return [`/users/${userId}/courses/${courseId}/modules/${moduleId}/exam-attempts/${attemptNumber}/report`] as const;
};

export const getGetExamAttemptReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getExamAttemptReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  attemptNumber: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExamAttemptReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExamAttemptReportQueryKey(userId, courseId, moduleId, attemptNumber);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getExamAttemptReport>>> = ({ signal }) =>
    getExamAttemptReport(userId, courseId, moduleId, attemptNumber, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && courseId && moduleId && attemptNumber),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getExamAttemptReport>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetExamAttemptReportQueryResult = NonNullable<Awaited<ReturnType<typeof getExamAttemptReport>>>;
export type GetExamAttemptReportQueryError = AxiosError<void | HTTPValidationError>;

export function useGetExamAttemptReport<
  TData = Awaited<ReturnType<typeof getExamAttemptReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  attemptNumber: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExamAttemptReport>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getExamAttemptReport>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetExamAttemptReport<
  TData = Awaited<ReturnType<typeof getExamAttemptReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  attemptNumber: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExamAttemptReport>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getExamAttemptReport>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetExamAttemptReport<
  TData = Awaited<ReturnType<typeof getExamAttemptReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  attemptNumber: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExamAttemptReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Exam Attempt Report
 */

export function useGetExamAttemptReport<
  TData = Awaited<ReturnType<typeof getExamAttemptReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  attemptNumber: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExamAttemptReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetExamAttemptReportQueryOptions(userId, courseId, moduleId, attemptNumber, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Reopen a graded oral fail so the student can register again.

Finished tasks stay marked done. Only oral-exam registration is unlocked.
 * @summary Retake Exam Attempt
 */
export const retakeExamAttempt = (
  userId: string,
  courseId: string,
  moduleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/users/${userId}/courses/${courseId}/modules/${moduleId}/exam-attempts/retake`,
    undefined,
    options,
  );
};

export const getRetakeExamAttemptMutationOptions = <
  TData = Awaited<ReturnType<typeof retakeExamAttempt>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['retakeExamAttempt'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retakeExamAttempt>>,
    { userId: string; courseId: string; moduleId: string }
  > = (props) => {
    const { userId, courseId, moduleId } = props ?? {};

    return retakeExamAttempt(userId, courseId, moduleId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string },
    TContext
  >;
};

export type RetakeExamAttemptMutationResult = NonNullable<Awaited<ReturnType<typeof retakeExamAttempt>>>;

export type RetakeExamAttemptMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Retake Exam Attempt
 */
export const useRetakeExamAttempt = <
  TData = Awaited<ReturnType<typeof retakeExamAttempt>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext> => {
  const mutationOptions = getRetakeExamAttemptMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Grant one more exam attempt. Can be repeated after each later fail.
 * @summary Grant Exam Attempt
 */
export const grantExamAttempt = (
  userId: string,
  courseId: string,
  moduleId: string,
  grantExamAttemptRequest: GrantExamAttemptRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/users/${userId}/courses/${courseId}/modules/${moduleId}/exam-attempts/grant`,
    grantExamAttemptRequest,
    options,
  );
};

export const getGrantExamAttemptMutationOptions = <
  TData = Awaited<ReturnType<typeof grantExamAttempt>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; data: GrantExamAttemptRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['grantExamAttempt'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantExamAttempt>>,
    { userId: string; courseId: string; moduleId: string; data: GrantExamAttemptRequest }
  > = (props) => {
    const { userId, courseId, moduleId, data } = props ?? {};

    return grantExamAttempt(userId, courseId, moduleId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; data: GrantExamAttemptRequest },
    TContext
  >;
};

export type GrantExamAttemptMutationResult = NonNullable<Awaited<ReturnType<typeof grantExamAttempt>>>;
export type GrantExamAttemptMutationBody = GrantExamAttemptRequest;
export type GrantExamAttemptMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Grant Exam Attempt
 */
export const useGrantExamAttempt = <
  TData = Awaited<ReturnType<typeof grantExamAttempt>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; data: GrantExamAttemptRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { userId: string; courseId: string; moduleId: string; data: GrantExamAttemptRequest },
  TContext
> => {
  const mutationOptions = getGrantExamAttemptMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Move a failed written module onto the newest published oral version.

After the version pin, every task except the oral exam is marked done.
 * @summary Upgrade Submission To Oral Exam
 */
export const upgradeSubmissionToOralExam = (
  userId: string,
  courseId: string,
  moduleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/users/${userId}/courses/${courseId}/modules/${moduleId}/exam-attempts/upgrade-to-oral`,
    undefined,
    options,
  );
};

export const getUpgradeSubmissionToOralExamMutationOptions = <
  TData = Awaited<ReturnType<typeof upgradeSubmissionToOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['upgradeSubmissionToOralExam'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradeSubmissionToOralExam>>,
    { userId: string; courseId: string; moduleId: string }
  > = (props) => {
    const { userId, courseId, moduleId } = props ?? {};

    return upgradeSubmissionToOralExam(userId, courseId, moduleId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string },
    TContext
  >;
};

export type UpgradeSubmissionToOralExamMutationResult = NonNullable<
  Awaited<ReturnType<typeof upgradeSubmissionToOralExam>>
>;

export type UpgradeSubmissionToOralExamMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Upgrade Submission To Oral Exam
 */
export const useUpgradeSubmissionToOralExam = <
  TData = Awaited<ReturnType<typeof upgradeSubmissionToOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext> => {
  const mutationOptions = getUpgradeSubmissionToOralExamMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Reassign Submission
 */
export const reassignSubmission = (
  submissionId: string,
  params: ReassignSubmissionParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(`/submissions/${submissionId}/reassign`, undefined, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getReassignSubmissionMutationOptions = <
  TData = Awaited<ReturnType<typeof reassignSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { submissionId: string; params: ReassignSubmissionParams }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['reassignSubmission'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reassignSubmission>>,
    { submissionId: string; params: ReassignSubmissionParams }
  > = (props) => {
    const { submissionId, params } = props ?? {};

    return reassignSubmission(submissionId, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { submissionId: string; params: ReassignSubmissionParams },
    TContext
  >;
};

export type ReassignSubmissionMutationResult = NonNullable<Awaited<ReturnType<typeof reassignSubmission>>>;

export type ReassignSubmissionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Reassign Submission
 */
export const useReassignSubmission = <
  TData = Awaited<ReturnType<typeof reassignSubmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { submissionId: string; params: ReassignSubmissionParams }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { submissionId: string; params: ReassignSubmissionParams }, TContext> => {
  const mutationOptions = getReassignSubmissionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Bulk Reassign Submissions
 */
export const bulkReassignSubmissions = (
  params: BulkReassignSubmissionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(`/submissions/reassign`, undefined, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getBulkReassignSubmissionsMutationOptions = <
  TData = Awaited<ReturnType<typeof bulkReassignSubmissions>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { params: BulkReassignSubmissionsParams }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['bulkReassignSubmissions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkReassignSubmissions>>,
    { params: BulkReassignSubmissionsParams }
  > = (props) => {
    const { params } = props ?? {};

    return bulkReassignSubmissions(params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { params: BulkReassignSubmissionsParams },
    TContext
  >;
};

export type BulkReassignSubmissionsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkReassignSubmissions>>>;

export type BulkReassignSubmissionsMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Bulk Reassign Submissions
 */
export const useBulkReassignSubmissions = <
  TData = Awaited<ReturnType<typeof bulkReassignSubmissions>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { params: BulkReassignSubmissionsParams }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { params: BulkReassignSubmissionsParams }, TContext> => {
  const mutationOptions = getBulkReassignSubmissionsMutationOptions(options);

  return useMutation(mutationOptions);
};
